import { setCurrentSupabaseOrganization as canonicalSetCurrentSupabaseOrganization } from '@/infrastructure/supabase';
import type { OrganizationContextPort } from '../ports/organizationContext.port';

export class SupabaseOrganizationContext implements OrganizationContextPort {
  async setCurrentOrganization(orgId: string): Promise<void> {
    return canonicalSetCurrentSupabaseOrganization(orgId);
  }
}

export const supabaseOrganizationContext = new SupabaseOrganizationContext();

export async function setCurrentSupabaseOrganization(orgId: string): Promise<void> {
  return canonicalSetCurrentSupabaseOrganization(orgId);
}

